<ion-content>
  <div class="upgrade-feature-banner" *ngIf="!featureEnabled">
    <div class="flex-space-between" style="align-items: center">
      Upgrade to track email support conversations
      <ion-button
        fill="outline"
        color="light"
        class="btn-small"
        [routerLink]="'/upgrade'"
        [queryParams]="{ plan: 'startup' }"
      >
        <ion-icon name="arrow-up-circle" class="padded-icon"></ion-icon>
        Upgrade account
      </ion-button>
    </div>
  </div>

  <div class="constrained-content">
    <ion-grid>
      <ion-row>
        <ion-col size-md="5" size="12" class="settings-title-section">
          <h1><ion-icon name="mail-outline"></ion-icon>Email Inboxes</h1>
          <p class="subtitle">
            Manage shared email inboxes from Unthread. Forward emails into a channel, discuss internally, and send
            replies from your dashboard or a Slack thread.
          </p>
          <p class="subtitle" style="margin-bottom: 15px">
            <a (click)="showEmailHelpdesk()">
              Learn more about email support
              <ion-icon name="chevron-forward-outline"></ion-icon>
            </a>
            <br />
            <br />
            <ion-badge *ngIf="validEmailDomains?.length" color="light">
              <ion-icon name="send-outline"></ion-icon>
              Sending from {{ validEmailDomains[0].domain }}
            </ion-badge>
            <br />

            <ion-badge *ngIf="!validEmailDomains?.length" color="light">
              <ion-icon name="information-circle"></ion-icon>
              Recommendation:
              <a routerLink="/dashboard/settings/security" routerDirection="root">validate your email domain</a>
            </ion-badge>
          </p>
        </ion-col>
        <ion-col size-md="7" size="12">
          <div class="add-button-container flex-space-between">
            <div></div>

            <ion-button (click)="addRule()">
              <ion-icon name="add-outline"></ion-icon>
              <span class="text-with-left-icon hidden-sm"> Create email inbox </span>
            </ion-button>
          </div>
          <ion-card
            class="outline-card"
            *ngFor="let rule of inboundEmailRules; let i = index"
            style="margin: 10px 10px 30px 10px"
          >
            <h3 style="margin: 20px 20px 5px 20px">
              {{ rule.name }}
            </h3>
            <ion-list>
              <ion-item>
                <ion-label> Email address: </ion-label>
                <ion-label>
                  <ion-icon class="list-left-icon" name="mail-outline"></ion-icon>
                  {{ rule.email }}
                </ion-label>
              </ion-item>
              <ion-item>
                <ion-label>Slack channel:</ion-label
                ><ion-label>
                  <ion-icon class="list-left-icon" name="logo-slack"></ion-icon>
                  {{ rule.slackChannel.name }}
                </ion-label>
              </ion-item>
              <ion-item
                ><ion-label> Status:</ion-label>
                <ion-label>
                  <ion-icon class="list-left-icon" name="ellipse" color="success"></ion-icon>
                  active
                </ion-label>
              </ion-item>
            </ion-list>
            <div style="border-top: 1px solid var(--ion-subtle-border-color)">
              <ion-button fill="clear" (click)="editInbox(rule)">
                <ion-icon name="cog-outline" class="padded-icon"></ion-icon>
                Edit configuration
              </ion-button>
            </div>
            <div>
              <ion-button fill="clear" (click)="viewInbox(rule)">
                <ion-icon name="file-tray-outline" class="padded-icon"></ion-icon>
                View conversations
              </ion-button>
            </div>
          </ion-card>
          <ion-card class="outline-card" *ngIf="!hasEmailRules" style="margin: 10px 10px 30px 10px">
            <div class="empty-state-container" style="padding: 60px">
              <span class="placeholder-emoji">
                <ion-icon name="mail-outline"></ion-icon>
              </span>
              <h1 class="placeholder-title">No inboxes yet</h1>
              <p class="placeholder-subtitle">Click the button above to set one up</p>
            </div>
          </ion-card>
        </ion-col>
      </ion-row>
    </ion-grid>
  </div>
</ion-content>

<ion-modal
  [isOpen]="showEmailInboxModal"
  class="modal-medium email-inbox-modal"
  (willDismiss)="onDismissEmailInboxModal()"
>
  <ng-template>
    <ion-header class="modal-header">
      <div class="modal-title">
        {{ inboxToEdit?.id ? 'Edit Inbox' : 'Create Email Inbox' }}
      </div>
      <ion-toolbar>
        <ion-buttons slot="end">
          <ion-button fill="clear" shape="round" class="close-button" (click)="onDismissEmailInboxModal()">
            <ion-icon name="close"></ion-icon>
          </ion-button>
        </ion-buttons>
      </ion-toolbar>
    </ion-header>
    <ion-content class="ion-padding" *ngIf="inboxToEdit">
      <ion-card-header>
        <ion-input
          [(ngModel)]="inboxToEdit.name"
          class="input-field big-title-input"
          placeholder="Name your inbox (ex: 'Email Support')"
          autocapitalize="sentences"
        >
        </ion-input>
      </ion-card-header>
      <ion-list>
        <ion-item>
          <h3 class="list-header">Email Forwarding</h3>
          <ion-button fill="clear" slot="end" (click)="showEmailHelpdesk()">
            <ion-icon name="information-circle" class="padded-icon"></ion-icon> Learn how to set up forwarding
          </ion-button>
        </ion-item>
        <ion-item>
          <ion-label> Enter company email address: </ion-label>
          <ion-input
            slot="end"
            style="text-align: right"
            placeholder="Ex: support@mydomain.com"
            [(ngModel)]="inboxToEdit.email"
            type="email"
          ></ion-input>
        </ion-item>
        <ion-item>
          <ion-label> Send replies from </ion-label>
          <ion-select [(ngModel)]="inboxToEdit.alwaysUseGenericEmailAddress" interface="popover" slot="end">
            <ion-select-option [value]="true"> This email address&nbsp;&nbsp;&nbsp;&nbsp; </ion-select-option>
            <ion-select-option [value]="false"> User's email address&nbsp;&nbsp;&nbsp;&nbsp; </ion-select-option>
          </ion-select>
        </ion-item>
        <ion-item>
          <ion-label> Reply with name </ion-label>
          <ion-input [(ngModel)]="inboxToEdit.replyName" placeholder="Ex: Support" slot="end" style="text-align: right"></ion-input>
        </ion-item>
        <ion-item>
          <ion-label> Forward emails to:</ion-label>
          <div class="email-section flex-space-between" slot="end">
            <span>{{ getForwardEmail(inboxToEdit) }}</span>
            <a ngxTippy data-tippy-content="Copy to clipboard" (click)="copyToClipboard(inboxToEdit)">
              <ion-icon name="copy-outline" style="margin-left: 12px"></ion-icon>
            </a>
          </div>
        </ion-item>
      </ion-list>

      <ion-list>
        <ion-item>
          <h3 class="list-header">Slack Channel</h3>
        </ion-item>
        <ion-item>
          <ion-label>Post to Slack channel: </ion-label>
          <div slot="end">
            <app-channel-selector
              [channel]="inboxToEdit.slackChannel"
              (channelDidChange)="onRuleChannelChanged(inboxToEdit, $event)"
              [defaultInternalOnly]="true"
              [hideUnlinkButton]="true"
            ></app-channel-selector>
          </div>
        </ion-item>
      </ion-list>

      <ion-card-title class="card-title">
        <h3 class="list-header">SLA</h3>
      </ion-card-title>
      <app-support-steps
        [initialSupportSteps]="inboxToEdit.supportSteps"
        (didChange)="supportStepsDidChange($event, inboxToEdit)"
      >
      </app-support-steps>

      <ion-card-title class="card-title flex-space-between" style="align-items: center">
        <h3 style="margin-bottom: 18px" class="list-header">Autoresponder</h3>
      </ion-card-title>

      <app-autoresponder
        [isDefault]="false"
        [initialAutoresponder]="inboxToEdit.autoresponder"
        (autoresponderDidChange)="autoresponderDidChange(inboxToEdit, $event)"
        [projectId]="projectId ?? undefined"
      ></app-autoresponder>

      <ion-card-title class="card-title">
        <h3 class="list-header">Blocked Emails & Domains</h3>
      </ion-card-title>
      <ion-list lines="none">
        <ion-item *ngFor="let entry of sortBlocklist(inboxToEdit); let i = index" class="blocklist-item">
          <ion-label color="danger">{{ entry }}</ion-label>
          <ion-button fill="clear" color="dark" (click)="deleteBlocklistEntry(inboxToEdit, i)">
            <ion-icon name="close-circle"></ion-icon>
          </ion-button>
        </ion-item>
        <ion-item>
          <ion-input
            placeholder="Add an email address (name@mail.com) or a domain (mail.com) and hit enter"
            [(ngModel)]="blockedEmailField"
            (keyup.enter)="addBlockedEmail(inboxToEdit)"
          ></ion-input>
        </ion-item>
      </ion-list>

      <ion-card-title class="card-title" *ngIf="inboxToEdit?.id">
        <h3 class="list-header">Advanced</h3>
      </ion-card-title>
      <ion-list *ngIf="inboxToEdit?.id">
        <ion-item>
          <ion-label text-wrap>
            <h3>Email Inbox ID</h3>
            <p>To be used in our API or Automations systems</p>
          </ion-label>
          <ion-label slot="end" class="email-section">{{ inboxToEdit?.id }}</ion-label>
        </ion-item>
      </ion-list>
    </ion-content>
    <ion-footer>
      <ion-button
        color="success"
        (click)="save(inboxToEdit)"
        class="save-button"
        [disabled]="!featureEnabled || isUpdatingInbox"
      >
        Save changes
      </ion-button>
      <ion-button fill="clear" (click)="cancelInboxEdit()"> Cancel </ion-button>
      <ion-button color="danger" fill="clear" (click)="delete()" *ngIf="inboxToEdit?.id" [disabled]="isUpdatingInbox"
        >Delete</ion-button
      >
    </ion-footer>
  </ng-template>
</ion-modal>
